import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import {Alert} from 'antd';
// import component
import MessageBoard from '../elements/MessageBoard';

const DataProcessingMessageBoard = (props) => {
  return (
    <div>
      {
        (props.announcement || props.announcement !== "")
        &&
        <Alert message={props.announcement} type="warning"/>
      }

      <MessageBoard messageBoardItems = {props.messageBoardItems} />
    </div>
  )
}

export default DataProcessingMessageBoard;